import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../assets/logo.jpg";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">

        {/* Top row: brand + nav + social */}
        <div className="footer-top">

          {/* Brand */}
          <div className="footer-brand">
            <img src={logo} alt="ComLinkr logo" className="footer-logo" />
            <div className="footer-brand-text">
              <span className="footer-title">ComLinkr</span>
              <span className="footer-tagline">Find Your Community</span>
            </div>
          </div>

          {/* Links */}
          <nav className="footer-links" aria-label="Footer navigation">
            <Link to="/about">About</Link>
            <Link to="/mission">Mission</Link>
            <Link to="/vision">Vision</Link>
            <Link to="/support">Support</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/delete-account">Delete Account</Link>
            <Link to="/child-safety">Child Safety</Link>
            <a
              href="https://forms.gle/kQ8y3imGQvyE6yZW8"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-careers"
            >
              Careers
            </a>
          </nav>

          {/* Social */}
          <div className="footer-social">
            <a
              href="https://www.linkedin.com/company/comlinkr/"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
              className="social-chip"
            >
              in
            </a>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="footer-bottom">
          <span>© 2026 ComLinkr. All rights reserved.</span>
          <span className="footer-made">Connecting communities, worldwide.</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
